import { ACCESS_TOKEN_NAME, JSON_CONTENT_TYPE } from '../../_constant/constants';
import { CustomerUpdateCustomerDto } from '../../_dto/_customer/CustomerUpdateCustomerDto';
import { IApiParams } from '../../_interface/IApiParams';
import { getApi } from '../getApi';

export const apiUpdateCustomer = async (customerUpdateCustomerDto: CustomerUpdateCustomerDto) => {
  const params: IApiParams = {
    url: '/customer/updateCustomer.php',
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      'Access-Token': localStorage.getItem(ACCESS_TOKEN_NAME), 
    },
  };
  return getApi(params, 'PUT', customerUpdateCustomerDto);
};
